module.exports="#define GLSLIFY 1\n  varying vec3 vWorldNormal;\n  void main() {\n    gl_FragColor.rgb = vWorldNormal;\n  }";